/*
 * Novicell master
 *  Author: APN modified by DLA
 *  Use this file to call functions in other files, on document ready, window.resize etc.
 *  ------
 * Dependencies: jquery, novicell.js, other files with awesome functions.
 *  Usage: $(function () {
 *              HornstrupKursuscenter.slider.heroSlider($('.owl-carousel'));
 *         }); // Document ready end
 */

var novicell = novicell || {};
var hornstrup = hornstrup || {};
novicell.initMaster = function() {
// Document ready
$(function () {
    // Only include Novicell functions that you use!
    novicell.map.init();
    novicell.cookieInfo.init();
    novicell.embed.loadEmbeds();
    novicell.responsiveLazyloadImage.image();
    hornstrup.mobilenav.init();
    hornstrup.countTo.init();
    hornstrup.countTo.checkIfCounterShouldRun();
    responsiveBackgroundImage();
    hornstrup.backgroundVideo.checkVideo();
    hornstrup.imageOverlayBlendModeNotSupported.init();
    hornstrup.googleMaps.init();
    hornstrup.share.init();
    hornstrup.breadcrumb.placeIt();
    hornstrup.contourCustom.init();
    hornstrup.searchOverlay.init();
    hornstrup.list4List3.init();




    //$('#nav-mobile-trigger').trigger('click')

    // Call new functions here like this:
    //HornstrupKursuscenter.slider.heroSlider($('.owl-carousel'));
    svg4everybody(); // Fix SVG spritemap in IE/Edge

}); // Document ready end


/*
 *  Use the following if needed
 */

// Window load
// $(window).load(function(e){
//     // call functions here
// }); // Window load

// Window resize (debounced)
$(window).smartresize(function(e){
    novicell.responsiveLazyloadImage.onResize();
    novicell.embed.onResize();
    hornstrup.countTo.checkIfCounterShouldRun();
    hornstrup.backgroundVideo.checkVideo();
}); // Window resize

// Window scroll (debounced)
$(window).smartscroll(function (e) {
    // call functions here
    novicell.responsiveLazyloadImage.image();
    responsiveBackgroundImage();
    if ($('.embed-media__item').length) {
        novicell.embed.loadEmbeds();
    }
    hornstrup.countTo.checkIfCounterShouldRun();
}); // Window scroll

// // Window mousemove (debounced)
// $(window).smartmousemove(function(e){
//     // do stuff as soon as the user stops moving his mouse for longer than 100ms
// }); // Window mousemove


// Makes the jumbotron image bandwidth friendly
function responsiveBackgroundImage() {
    [].forEach.call(document.querySelectorAll(".responsiveBackgroundImage"), function (el) {
        if (el.hasAttribute("data-bgimg")) {
            var bgimg = el.getAttribute("data-bgimg");
            var w = el.offsetWidth;
            var wRnd = Math.round(w / 50) * 50 + 50;
            el.setAttribute("style", "background-image:url('" + bgimg + "?width=" + wRnd + "&quality=70');");
        }
    });
}
}